<template>
  <div class="news">新闻中心</div>
</template>

<script>
export default {
  data () {
    return {}
  }
}

</script>

<style scoped>

</style>